import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState } from "react";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import DOMPurify from "dompurify";

export default function DeductActivationFund() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [activamount, setActivation] = useState("");
  const [name, setName] = useState("");

  const [utr, setUtr] = useState("");
  const [usd, setUsd] = useState(0);
  const [Token, setToken] = useState(0);
  const [ethereum, setEthereum] = useState(0);

  const handleChange = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      "",
    );
    const limitedValue = sanitizedValue.slice(0, 8);

    setSearch(limitedValue);
    CheckUserId_Api(limitedValue);
  };

  const CheckUserId_Api = async (value) => {
    try {
      let res = await API.post(
        "/CheckUserId",
        {
          loginid: userId,
          uid: value,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      //   console.log("cuser_Api", res.data);
      if (res?.data?.data === "WrongId") {
        setName("Wrong Id");
      } else {
        setSearch(value);
        setName(res?.data?.data);
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleAmount = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value).replace(
      /\D/g,
      "",
    );
    const limitedValue = sanitizedValue.slice(0, 8);

    setActivation(limitedValue);
    //CheckAmount_Api(limitedValue);
  };

  const CheckAmount_Api = async (camount) => {
    try {
      let res = await API?.post(
        "/ConvertAmount",
        {
          loginid: userId,
          TokenValue: 0,
          EthValue: 0,
          USDValue: camount,
          type: "buy",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      //   console.log("amount_Api", res?.data?.data);
      setUsd(res?.data?.data?.usd);
      setToken(res?.data?.data?.Token);
      setEthereum(res?.data?.data?.ethereum);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const referral_API = async () => {
    if (search && activamount) {
      try {
        let responceRight = await API?.post(
          "/DeductTransfer",
          {
            loginid: userId,
            uid: search,
            amount: activamount,
            txn: utr,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          },
        );

        //console.log("My_Team", responceRight.data.data);
        if (responceRight.data.data == "Success") {
          toast.success("Deduct Fund Successfully !!");
          setActivation("");
          setSearch("");
          setName("");
          setUtr("");
        } else {
          toast.error(responceRight.data.data);
        }
      } catch (e) {
        console.log("error Balance APi", e);
        if (
          e.response.data.showableMessage ==
          "Please login to access this resource"
        ) {
          dispatch(
            updateAuth({ AdminAuth: false, jwt_token: "", userId: null }),
          );
          sessionStorage.clear();
          localStorage.clear();
          navigate("/");
        }
      }
    } else {
      toast.error("Please Fill All The Fields");
    }
  };

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Deduct Trading Fund</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="d-flex justify-content-between">
                                  <h1>Deduct Trading Fund</h1>
                                  <Link
                                    to="/activationfundHis"
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 10px",
                                      marginTop: "20px",
                                      background: "#0d37a5",
                                    }}
                                  >
                                    Deduct Trading Fund History
                                  </Link>
                                </div>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>User Id</label>
                                  <input
                                    type="text"
                                    // inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter User Id"
                                    value={search}
                                    onChange={handleChange}
                                  />
                                  {name && (
                                    <p
                                      className={
                                        name === "Wrong Id"
                                          ? "text-danger"
                                          : "text-success"
                                      }
                                    >
                                      {name}
                                    </p>
                                  )}
                                </div>

                                <div className="form-group">
                                  <label>Amount</label>
                                  <input
                                    type="number"
                                    inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Amount"
                                    value={activamount}
                                    onChange={handleAmount}
                                  />
                                </div>

                                <div className="form-group">
                                  <label>Txn</label>
                                  <input
                                    type="text"
                                    maxLength={20}
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Remark"
                                    value={utr}
                                    onChange={(e) => setUtr(e.target.value)}
                                  />
                                </div>
                                <div class="joinbtn d-flex  me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => referral_API()}
                                  >
                                    Fund Deduct
                                  </button>
                                </div>
                                {/* <div class="joinbtn d-flex flex-row-reverse me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                    }}
                                    onClick={() => Deduct_API()}>
                                    Fund Deduct
                                  </button>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
